import { useMutation, useQuery, useQueryClient } from "react-query";
import moment from "moment";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useAddTaskSplits = (taskId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      fetch({
        url: `${Angie.api_url}/task-splits/${taskId}`,
        method: "POST",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(["task-splits", taskId]);
    },
  });
};

export const useEditTaskSplits = (taskId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/task-splits/${taskId}`,
        method: "PUT",
        body: data,
      }),
    onMutate: (args) => {
      const dates = Object.keys(args);
      const previous = queryClient.getQueryData(["task-splits", taskId]);

      if (previous && previous.splits && dates.length > 0) {
        let momentDate;
        let result = {
          ...previous,
        };
        dates.forEach((date) => {
          if (typeof date === "number") {
            momentDate = moment.unix(date).utc();
          } else {
            momentDate = moment.utc(date);
          }
          if (momentDate) {
            const newSplits = previous.splits.reduce((prev, split) => {
              if (moment.unix(split.date).isAfter(momentDate)) {
                prev.push({
                  ...split,
                  pending: true,
                });
              } else {
                prev.push({
                  ...split,
                  disabled: true,
                });
              }
              return prev;
            }, []);

            result = {
              ...result,
              splits: newSplits,
            };
          }
        });

        queryClient.setQueriesData(["task-splits", taskId], () => {
          return result;
        });
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["task-splits", taskId]);
    },
    onError: () => {
      queryClient.invalidateQueries(["task-splits", taskId]);
    },
  });
};

export const useDeleteTaskSplits = (taskId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      fetch({
        url: `${Angie.api_url}/task-splits/${taskId}`,
        method: "DELETE",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(["task-splits", taskId]);
    },
  });
};

export const useTaskSplits = (taskId, config) => {
  return useQuery({
    ...config,
    queryKey: ["task-splits", taskId],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/task-splits/${taskId}`,
        method: "GET",
        signal,
      }),
  });
};
